import { all } from "redux-saga/effects";
import { mucThuSaga } from "./mucThuSaga";
import { mucThuTinChiSaga } from "./mucThuTinChiSaga";
import { mucThuTamThuSaga } from "./mucThuTamThuSaga";

export default function* mucThuSagaWrapper() {
  yield all([mucThuSaga(), mucThuTinChiSaga(), mucThuTamThuSaga()]);
}
